module.exports = __webpack_public_path__ + "img/StbHorizontalLogo.0f9d4a6d.png";